export const deliveryMenus = {
	header: {
		mainTitle: "Menús",
		mainDescription: "Visualice, cree y edite menús de Delivery.",
		editDescription: "Visualice y edite su menú.",
	},
	status: {
		active: "Activo",
		pendingSync: "Sinc. Pendiente",
		pendingImport: "Importación pendiente",
		inactive: "Inactivo",
		synced: "Sincronizado",
	},
	tabs: {
		importedMenus: "Menús importados",
		whiteLabelMenus: "Whitelabel",
	},
	menuCard: {
		message: "funcionamiento 24h",
		at: "a las",
		delivery: "Delivery",
		table: "Pedido en mesa",
		businessHour: "Horario de funcionamiento",
		type: "Tipo",
		importedAt: "Importado el",
		createdAt: "Creado el",
		products: "Productos",
		numberOfProducts: "{{ number }} Productos",
		unsyncedProducts: "productos no sincronizados",
		notImportedProducts: "productos no importados",
	},
	actions: {
		seeMenu: "Ver menú",
		continueImport: "Continuar importación",
		continueSync: "Continuar sincronización",
		create: "Crear nuevo",
		import: "Importar menú",
		search: "Buscar menús",
		manualMode: "Modo manual",
		editMenu: "Editar menú",
		deleteMenu: "Eliminar menú",
		addProduct: "Agregar producto",
		searchProduct: "Buscar producto",
	},
	categories: {
		appetizers: "Entradas",
		mainCourses: "Platos Principales",
		desserts: "Postres",
		nonAlcoholicDrinks: "Bebidas no alcohólicas",
		alcoholicDrinks: "Drinks",
	},
	emptyState: {
		title: "Menú para delivery",
		message: "Parece que aún no tiene ningún menú creado",
		create: "Crear Menú",
		integration: "Importar menú",
	},
};
